export const apiV1 = process.env.REACT_APP_API_URL_V1
export const apiV2 = process.env.REACT_APP_API_URL_V2
export const api = process.env.REACT_APP_API_URL
export const webUrl = process.env.REACT_APP_WEB_URL
export const cdnUrl = process.env.REACT_APP_CDN_URL
export const homeUrl = process.env.REACT_APP_HOME_URL
